<template>
  <div class="container-fluid">
    <ProductList :initialSearchTerm="searchTerm" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ProductList from '@/components/ProductList.vue';

const route = useRoute();
const searchTerm = computed(() => route.query.search || '');
</script>
